// extracted by mini-css-extract-plugin
export default {"questionExplanation":"R_c3"};